import React from 'react';
import { Box } from '@mui/material';

const DOG_LOGO_SRC = `${process.env.PUBLIC_URL}/images/logo-cao.jpg`;
const FARM_LOGO_SRC = `${process.env.PUBLIC_URL}/images/fazenda.png`;

type IconProps = {
  size?: number;
  onClick?: () => void;
};

const imageIconSx = (size: number) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  objectFit: 'cover' as const,
  display: 'block',
  flexShrink: 0,
  boxShadow: size >= 100 ? '0 8px 32px rgba(0, 0, 0, 0.35)' : '0 1px 4px rgba(0, 0, 0, 0.15)',
});

/** Logo do cão — itens dispensados / seção Cães */
export const DogChecklistIcon: React.FC<IconProps> = ({ size = 52, onClick }) => (
  <Box
    component="img"
    src={DOG_LOGO_SRC}
    alt=""
    aria-hidden={!onClick}
    onClick={onClick}
    sx={imageIconSx(size)}
  />
);

/** Logo da fazenda — itens dispensados / seção Fazenda */
export const RusticFarmIcon: React.FC<IconProps> = ({ size = 52, onClick }) => (
  <Box
    component="img"
    src={FARM_LOGO_SRC}
    alt=""
    aria-hidden={!onClick}
    onClick={onClick}
    sx={imageIconSx(size)}
  />
);
